import {useCallback} from 'react';

import {MapRef} from '~types/Map';

export default function useZoomEvent(map: MapRef) {
    const zoomMap = useCallback((zoomIn = true) => {
        if (!map.current) return;
        if (zoomIn) {
            map.current.zoomIn();
        } else {
            map.current.zoomOut();
        }
    }, []);

    return {
        zoomIn: () => zoomMap(),
        zoomOut: () => zoomMap(false),
    };
}
